import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CityDropdown from "./CityDropdown";
import DeveloperDropdown from "./developerdropdown";
import ProjectDropdown from "./projectdropdown";
import "./PropertySearch.css";

const RENT_PRICES = [
  40000, 50000, 60000, 70000, 80000, 90000, 100000,
  200000, 300000, 400000, 500000, 600000, 700000,
  800000, 900000, 1000000
];

const BUY_PRICES = [
  400000, 500000, 600000, 700000, 800000,
  900000, 1000000, 2000000, 3000000, 4000000,
  5000000, 6000000, 7000000, 8000000, 9000000,
  10000000, 20000000, 30000000, 40000000, 50000000, 100000000
];

const RESIDENTIAL_TYPES = [
  "Apartment",
  "Loft",
  "Duplex",
  "Penthouse",
  "Villa",
  "Semi-Detached Villa",
  "Townhouse",
  "Residential Land",
];

const COMMERCIAL_TYPES = [
  "Office",
  "Retail Shop",
  "Showroom",
  "Warehouse",
  "Commercial Villa",
  "Commercial Land",
  "Mixed-Use Land",
];
 

const PropertySearchControlHome = ({ onSearch }) => {
  const navigate = useNavigate();

  const [offerType, setOfferType] = useState("Sale");
  const [city, setCity] = useState(null); 
  const [propertyCategory, setPropertyCategory] = useState("");
  const [propertyType, setPropertyType] = useState("");

  const [developer, setDeveloper] = useState("");
  const [project, setProject] = useState("");

  const [beds, setBeds] = useState("");
  const [baths, setBaths] = useState("");
  const [showBedsPopup, setShowBedsPopup] = useState(false);

  const [minArea, setMinArea] = useState("");
  const [maxArea, setMaxArea] = useState("");
  const [showAreaPopup, setShowAreaPopup] = useState(false);

  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [showPricePopup, setShowPricePopup] = useState(false);

  const bedsRef = useRef(null);
  const areaRef = useRef(null);
  const priceRef = useRef(null);

  const isLatestLaunches = offerType === "Latest Launches";

  const priceOptions =
    offerType === "Rent"
      ? RENT_PRICES
      : BUY_PRICES;

  useEffect(() => {
    setMinPrice("");
    setMaxPrice("");

    if (offerType !== "Latest Launches") {
      setDeveloper("");
      setProject("");
    }
  }, [offerType]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        bedsRef.current && !bedsRef.current.contains(e.target) &&
        areaRef.current && !areaRef.current.contains(e.target) &&
        priceRef.current && !priceRef.current.contains(e.target)
      ) {
        setShowBedsPopup(false);
        setShowAreaPopup(false);
        setShowPricePopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = () => {
    const queryParams = new URLSearchParams({
      offering_type: offerType,
      city: city?.value || "",
      ...(!isLatestLaunches && propertyCategory
        ? { property_category: propertyCategory }
        : {}),
      property_type: isLatestLaunches ? "" : propertyType,
      bedrooms: isLatestLaunches ? "" : beds,
      bathrooms: isLatestLaunches ? "" : baths,
      developer: developer?.value || "",
      developer_name: developer?.label || "",
      project: project?.value || "",
      project_name: project?.label || "",
      minArea: isLatestLaunches ? "" : minArea,
      maxArea: isLatestLaunches ? "" : maxArea,
      minPrice: isLatestLaunches ? "" : minPrice,
      maxPrice: isLatestLaunches ? "" : maxPrice,
    }).toString();

    navigate(
      isLatestLaunches
        ? `/new-projects?${queryParams}`
        : `/property-search-result?${queryParams}`
    );
  };

  return (
    <div className="search-container">
      <div
        className={
          isLatestLaunches
            ? "search-top latest-launches-home-search-row"
            : "search-top"
        }
      >
        <div className="buy-rent-toggle width100">
          <button
            className={offerType === "Sale" ? "active toggel-first" : "toggel-first"}
            onClick={() => setOfferType("Sale")}
          >
            Buy
          </button>

          <button
            className={offerType === "Rent" ? "active" : ""}
            onClick={() => setOfferType("Rent")}
          >
            Rent
          </button>

          <button
            className={isLatestLaunches ? "active toggel-last" : "toggel-last"}
            onClick={() => setOfferType("Latest Launches")}
          >
            Latest Launches
          </button>
        </div>

        <div className="location-box">
          <CityDropdown value={city} onChange={setCity} />
        </div>

        {isLatestLaunches && (
          <>
            <DeveloperDropdown value={developer} onChange={setDeveloper} />
            <ProjectDropdown value={project} onChange={setProject} />
          </>
        )}

        <button className="search-main-btn" onClick={handleSearch}>
          Search
        </button>
      </div>

      {!isLatestLaunches && (
        <div className="search-filters">
            <select
              value={propertyCategory}
              onChange={(e) => {
                setPropertyCategory(e.target.value);
                setPropertyType("");
              }}
            >
              <option value="">All</option>
              <option value="Residential">Residential</option>
              <option value="Commercial">Commercial</option>
            </select>

            <select value={propertyType} onChange={(e) => setPropertyType(e.target.value)}>
              <option value="">Property Type</option>
              {(propertyCategory === "Residential"
                ? RESIDENTIAL_TYPES
                : propertyCategory === "Commercial"
                  ? COMMERCIAL_TYPES
                  : [...RESIDENTIAL_TYPES, ...COMMERCIAL_TYPES]).map(
                (type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                )
              )}
            </select>

            <div className="popup-wrapper price-input" ref={bedsRef}>
              <button
                className="popup-trigger"
                onClick={() => {
                  setShowBedsPopup(!showBedsPopup);
                  setShowAreaPopup(false);
                  setShowPricePopup(false);
                }}
              >
                {beds || baths ? `${beds || 0} Beds • ${baths || 0} Baths` : "Beds & Baths"}
              </button>

              {showBedsPopup && (
                <div className="popup-card-price">
                  <div className="popup-row">
                    <span>Beds</span>
                    <select value={beds} onChange={(e) => setBeds(e.target.value)}>
                      <option value="">Any</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="5+">5+</option>
                    </select>
                  </div>

                  <div className="popup-row">
                    <span>Baths</span>
                    <select value={baths} onChange={(e) => setBaths(e.target.value)}>
                      <option value="">Any</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="5+">5+</option>
                    </select>
                  </div>

                  <button className="popup-apply" onClick={() => setShowBedsPopup(false)}>
                    Apply
                  </button>
                </div>
              )}
            </div>

          <div className="popup-wrapper price-input" ref={areaRef}>
          <button
            className="popup-trigger"
            onClick={() => {
              setShowAreaPopup(!showAreaPopup);
              setShowBedsPopup(false);
              setShowPricePopup(false);
            }}
          >
            {minArea || maxArea ? `${minArea || 0} - ${maxArea || "Any"} Sqft` : "Area"}
          </button>

          {showAreaPopup && (
            <div className="popup-card-price">
              <div className="popup-row">
                <span>Min Area (Sqft)</span>
                <input
                  type="number"
                  min={100}
                  value={minArea}
                  onChange={(e) => setMinArea(e.target.value)}
                />
              </div>

              <div className="popup-row">
                <span>Max Area (Sqft)</span>
                <input
                  type="number"
                  min={100}
                  value={maxArea}
                  onChange={(e) => setMaxArea(e.target.value)}
                />
              </div>

              <button className="popup-apply" onClick={() => setShowAreaPopup(false)}>
                Apply
              </button>
            </div>
          )}
        </div>

        <div className="popup-wrapper price-input" ref={priceRef}>
          <button
            className="popup-trigger"
            onClick={() => {
              setShowPricePopup(!showPricePopup);
              setShowBedsPopup(false);
              setShowAreaPopup(false);
            }}
          >
            {minPrice || maxPrice
              ? `AED ${minPrice || priceOptions[0]} - ${maxPrice || "Any"}${
                  offerType === "Rent" ? " / year" : ""
                }`
              : `Price (AED${offerType === "Rent" ? " / Year" : ""})`}
          </button>

          {showPricePopup && (
            <div className="popup-card-price">
              <div className="popup-row">
                <span>Min Price</span>
                <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
                  <option value="">Any</option>
                  {priceOptions.map((p) => (
                    <option key={p} value={p}>
                      AED {p.toLocaleString()}
                    </option>
                  ))}
                </select>
              </div>

              <div className="popup-row">
                <span>Max Price</span>
                <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
                  <option value="">Any</option>
                  {priceOptions.map((p) => (
                    <option key={p} value={p}>
                      AED {p.toLocaleString()}
                    </option>
                  ))}
                </select>
              </div>

              <button className="popup-apply" onClick={() => setShowPricePopup(false)}>
                Apply
              </button>
            </div>
          )}
        </div>

        <button className="search-mobile-btn" onClick={handleSearch}>
          Search
        </button>
      </div>
      )}
    </div>
  );
};

export default PropertySearchControlHome;
